const initialState = {
  focusedItemUuid: null,
  yourFeed: [],
};

function homePage(state = initialState, action) {
  switch (action.type) {
    case 'UPDATE_FOCUSED_ITEM':
      return {
        ...state,
        focusedItemUuid: action.payload.uuid,
      };
    default:
      return state;
  }
}

export default homePage;
